import { createFileRoute } from "@tanstack/react-router";
import { DenomLandingPage } from "@/components/prize-bond/DenomLandingPage";
import { buildPrizeBondLandingHead } from "@/lib/prize-bond-landing-head";

const DENOM = 200;
const SLUG = "prize-bond-200-result-today";
const TITLE =
  "200 Prize Bond Result Today 2026 - Prize Bond Check Karne Ka Tarika - Check Prize Bond Online";
const DESC =
  "Rs. 200 wale prize bond ki list aaj — full winners checker Pakistan. Bulk, range aur single check with official National Savings data.";

const HOW_TO_STEPS = [
  { title: "Rs. 200 chip select karein", body: "Denomination bar mein blue Rs. 200 chip tap karein — bearer bond, sab ke liye open." },
  { title: "Number likhein", body: "Rs. 200 bond ke upar 6-digit serial number printed hota hai — wohi input mein daalein." },
  { title: "Bulk / range use karein", body: "Kayi bonds ho to Bulk tab (100 numbers) ya Range tab (500 consecutive numbers) use karein — sab ek click mein clear." },
  { title: "Green Check dabayein", body: "Winners scale-in animation ke sath green highlight ho jate hain, non-winners chotay grey tags mein neeche show hote hain." },
  { title: "Prize claim karein", body: "Draw ke 6 saal ke andar SBP branch se bond, CNIC copy aur claim form jama karayein — bara inaam cross cheque mein milega." },
];

const FAQS = [
  { q: "200 wale prize bond ki list aaj kaise dekhein?", a: "Upar checker mein Rs. 200 chip select karein aur apna bond number likhein — result foran nazar aayega. Chahen to bulk mode mein 100 tak numbers ek saath paste karke check kar sakte hain — pooray winners list se match ho jayega." },
  { q: "Rs. 200 prize bond ka first prize kitna hai?", a: "First prize Rs. 7,50,000 (7.5 lakh) — 1 winner. Second prize Rs. 2,50,000 (2.5 lakh) — 3 winners. Third prize Rs. 1,250 — 2,394 winners. Third-prize winners ki tadaad zyada hai isliye chota inaam jeetne ka chance behtar hai." },
  { q: "200 wala prize bond kab draw hoti hai?", a: "Rs. 200 draw quarterly hoti hai — usually March, June, September, December ke pehle hafte mein. Exact tareekh National Savings 15-20 din pehle publish karta hai." },
  { q: "Kya Rs. 200 bearer hai?", a: "Haan, Rs. 200 bearer bond hai — koi CNIC ya registration nahi chahiye. Cash mein SBP ya commercial bank ki kisi bhi branch se le sakte hain aur usi din wapis surrender bhi kar sakte hain." },
  { q: "Rs. 200 bond ka color code kya hai?", a: "Rs. 200 bond ka color blue hota hai — is se doosri denominations se pehchan mein aasani hoti hai. Purane bond bhi isi color scheme ke sath print hote hain." },
  { q: "200 prize bond par tax kitna lagta hai?", a: "Third prize Rs. 1,250 par koi tax nahi (Rs. 5,000 threshold se neeche hai). Second (Rs. 2.5 lakh) aur first (Rs. 7.5 lakh) par filer 15%, non-filer 30% withholding tax kata jata hai." },
  { q: "200 bond ka draw kis city mein hota hai?", a: "Draws rotation basis par 8 cities mein hote hain — Karachi, Lahore, Multan, Peshawar, Rawalpindi, Muzaffarabad, Quetta aur Faisalabad. Checker card par har draw ki city mention hoti hai." },
  { q: "Kya 200 wala bond gift karne ke liye acha hai?", a: "Bilkul — bearer form, sasta price (200 rupay), aur Rs. 7.5 lakh jackpot ki wajah se yeh popular gift item hai. Shadi, birthday ya Eidi mein bachon ko dene ke liye ideal denomination hai." },
  { q: "Rs. 200 bond ki purani draws bhi checker mein aati hain?", a: "Haan — jo bhi historical Rs. 200 draws upload hui hain, un sab ke against aap ke numbers match hote hain. Aik hi bond number multiple draws mein bhi jeeta ho to sab entries alag alag cards mein show hoti hain." },
  { q: "200 prize bond ka investment return realistic kitna hai?", a: "Statistically, agar aap 50 Rs. 200 bonds rakhein (total Rs. 10,000) to 2-3 saal mein kam se kam ek third prize Rs. 1,250 ki umeed rehti hai — matlab ~4-6% annualized expected return plus jackpot upside." },
];

const RELATED = [
  { href: "/prize-bond-100-result-today", label: "Rs. 100 Prize Bond" },
  { href: "/prize-bond-list-750-today", label: "Rs. 750 Prize Bond" },
  { href: "/prize-bond-1500-result-today", label: "Rs. 1,500 Prize Bond" },
  { href: "/prize-bond-25000-result-today", label: "Rs. 25,000 Premium" },
  { href: "/prize-bond-40000-result-today", label: "Rs. 40,000 Premium" },
  { href: "/prize-bond", label: "All Prize Bonds Hub" },
];

export const Route = createFileRoute("/prize-bond-200-result-today")({
  head: () =>
    buildPrizeBondLandingHead({
      slug: SLUG,
      title: TITLE,
      description: DESC,
      denomination: DENOM,
      howToName: "How to check Rs. 200 Prize Bond result today",
      howToSteps: HOW_TO_STEPS,
      faqs: FAQS,
    }),
  component: Page,
});

function Page() {
  return (
    <DenomLandingPage
      denomination={DENOM}
      h1English="200 Prize Bond Result Today — Full Winners List & Checker"
      h1Hinglish="200 Wale Prize Bond Ki List Aaj — Ek Click Mein Nikaalain"
      introParagraphs={[
        "Rs. 200 Pakistan ka doosra sab se sasta bearer prize bond hai — sirf 200 rupay mein Rs. 7.5 lakh jackpot aur 2,394 chotay winners ki full list. Rs. 100 ke baad yeh sab se accessible entry point hai jo aksar log gift karne, ya chotay portfolio banane ke liye kharidte hain.",
        "Is page par upar diya checker seedha National Savings Pakistan ki official Rs. 200 draw PDF ke against match karta hai. Draw complete hote hi hamara backend winners parse karke checker mein feed kar deta hai — matlab aap ko koi list PDF download karke Ctrl+F karne, ya WhatsApp forwards ka wait karne ki zarurat nahi.",
        "Neeche checker ke baad Rs. 200 ki full prize structure, tax rules, gifting use-case aur unique FAQs milengi — sirf isi denomination ke user context mein likhi hui.",
      ]}
      keyFacts={[
        { label: "1st Prize", value: "Rs. 7,50,000" },
        { label: "2nd Prize (×3)", value: "Rs. 2,50,000" },
        { label: "3rd Prize (×2394)", value: "Rs. 1,250" },
        { label: "Color", value: "Blue · Bearer" },
      ]}
      sections={[
        {
          id: "200-vs-100-750",
          heading: "Rs. 200 vs Rs. 100 vs Rs. 750 — Kaunsa Behtar",
          body: (
            <>
              <p>
                Rs. 100 bond mein 1,199 third prize winners hain, Rs. 200 mein 2,394 (double), aur Rs. 750 mein 1,696. Matlab
                Rs. 200 par chota inaam jeetne ke chances numerically sab se zyada hain. Prize amount bhi Rs. 1,250 hai — Rs. 100
                bond ke Rs. 1,000 se 25% zyada. Isliye jo log chotay prizes ki frequency chahte hain, unke liye Rs. 200 sab se
                efficient denomination banti hai.
              </p>
              <p>
                Rs. 750 wala bond bara jackpot (Rs. 15 lakh) deta hai lekin per-bond cost 3.75x hai — matlab same capital mein
                aap Rs. 200 wale zyada bonds rakh sakte hain aur diversification behtar hoti hai.
              </p>
            </>
          ),
        },
        {
          id: "third-prize-math",
          heading: "Third Prize Ka Simple Math",
          body: (
            <>
              <p>
                Third prize Rs. 1,250 par koi tax nahi (Rs. 5,000 threshold se neeche). Agar aap ne 100 Rs. 200 bonds
                rakhein (total Rs. 20,000), to statistically 12-18 mahine mein kam se kam ek third prize jeetne ka
                realistic chance hai. Matlab 6-8% return of investment plus principal 100% safe (SBP guarantee) plus
                jackpot ka upside — Pakistan mein bank savings rate se comparable hai.
              </p>
            </>
          ),
        },
      ]}
      howToSteps={HOW_TO_STEPS}
      faqs={FAQS}
      relatedLinks={RELATED}
    />
  );
}
